import {createSlice} from '@reduxjs/toolkit';
import {Dimensions} from 'react-native';
import {Platform} from 'react-native';
import {isMobileOnly, isTablet} from 'react-device-detect';

const screenWidth = Dimensions.get('window').width;
const screenHeight = Dimensions.get('window').height;

const initialState = {
   isLandscapemode:
      Platform.OS === 'web' && !isMobileOnly && screenWidth > screenHeight
         ? true
         : false,
   isLandscapeSmallWebView:
      Platform.OS === 'web' &&
      isMobileOnly &&
      Math.max(screenHeight, screenWidth) > 450 &&
      screenHeight < screenWidth
         ? true
         : false,
   showLandscapeMsg: true,
   isTabletPortrait: isTablet && screenHeight > screenWidth,
   isBottomLogoToShown: true,
};

const ScreenOrientationSlice = createSlice({
   name: 'screenOrientation',
   initialState,
   reducers: {
      setIsLandscapemode: (state, action) => {
         state.isLandscapemode = action.payload.isLandscapemode;
      },
      setIsLandscapeSmallWebView: (state, action) => {
         state.isLandscapeSmallWebView = action.payload.isLandscapeSmallWebView;
      },
      setShowLandscapeMsg: (state, action) => {
         state.showLandscapeMsg = action.payload.showLandscapeMsg;
      },
      setIsTabletPortrait: (state, action) => {
         state.isTabletPortrait = action.payload.isTabletPortrait;
      },
      setIsBottomLogoToShown: (state, action) => {
         state.isBottomLogoToShown = action.payload.isBottomLogoToShown;
      },
   },
});

export const {
   setIsLandscapemode,
   setIsLandscapeSmallWebView,
   setShowLandscapeMsg,
   setIsTabletPortrait,
   setIsBottomLogoToShown,
} = ScreenOrientationSlice.actions;

export const selectScreenOrientation = state =>
   state.screenOrientation.isLandscapemode;
export const selectLandscapeSmallWebView = state =>
   state.screenOrientation.isLandscapeSmallWebView;
export const getShowLandscapeMsg = state =>
   state.screenOrientation.showLandscapeMsg;
export const getIsTabletPortrait = state =>
   state.screenOrientation.isTabletPortrait;
export const getIsBottomLogoToShown = state =>
   state.screenOrientation.isBottomLogoToShown;

export default ScreenOrientationSlice.reducer;
